/** @format */
import parse from "html-react-parser";

import { error as errorToast } from "../Components/Toast";
import useApi from "../hooks/api/Index";

export const getStep = async (stepName) => {
  let step = undefined;
  await useApi.get(
    `/general/step/${stepName}`,
    {},
    (res) => {
      let data = res.data.data;
      step = data;
    },
    (err) => {
      console.log(err);
    }
  );
  return step;
};

export const getSteps = async () => {
  let step = [];
  await useApi.get(
    `/general/step`,
    {},
    (res) => {
      let data = res.data.data;
      data.forEach((el) => {
        step.push(el.step_name);
      });
    },
    (err) => {
      console.log(err);
    }
  );
  return step;
};
export const showFirstRequestError = (errors) => {
  Object.values(errors).forEach((err) => {
    errorToast(err[0]);
  });
};

export const htmlToJsx = (html) => {
  return parse(html ?? "");
};

export const number_format = (Number) => {
  Number += "";
  Number = Number.replace(",", "");
  Number = Number.replace(",", "");
  Number = Number.replace(",", "");
  Number = Number.replace(",", "");
  Number = Number.replace(",", "");
  Number = Number.replace(",", "");
  let x = Number.split(".");
  let y = x[0];
  let z = x.length > 1 ? "." + x[1] : "";
  let rgx = /(\d+)(\d{3})/;
  while (rgx.test(y)) y = y.replace(rgx, `$1,$2`);
  return y + z;
};

export const baseApiUrl = () =>
  process.env.REACT_APP_API_URL || "https://championapi.bbbf.ir/api/v1";
export const siteBaseUrl = () =>
  process.env.REACT_APP_SITE_URL || "https://champion.bbbf.ir";

/**
 * Build and submit a payment gateway form from the backend RedirectionForm
 * payload ({ action, method, inputs }). This keeps the gateway URL and fields
 * driven entirely by the backend, so the SEP OnlinePG flow works without any
 * hardcoded endpoint on the frontend.
 */
export const submitGatewayForm = (payload, target = "") => {
  if (!payload || !payload.action) {
    return false;
  }

  const form = document.createElement("form");
  form.method = (payload.method || "POST").toUpperCase();
  form.action = payload.action;
  form.target = target;

  const inputs = payload.inputs || {};
  Object.entries(inputs).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value === null || value === undefined ? "" : value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();

  return true;
};

export const numToEn = (number) => {
  return number
    .replace(/[\u0660-\u0669]/g, function (c) {
      return c.charCodeAt(0) - 0x0660;
    })
    .replace(/[\u06f0-\u06f9]/g, function (c) {
      return c.charCodeAt(0) - 0x06f0;
    });
};

export const isValidIranianNationalCode = (input) => {
  if (!/^\d{10}$/.test(input)) return false;
  const check = +input[9];
  const sum =
    input
      .split("")
      .slice(0, 9)
      .reduce((acc, x, i) => acc + +x * (10 - i), 0) % 11;
  return sum < 2 ? check === sum : check + sum === 11;
};

export const isValidForeignersCode = (value) => {
  let input = value.replace("FGN-", "");
  if (
    input.length !== 8 &&
    input.length !== 11 &&
    (input.length < 8 ||
      input.length > 8 ||
      input.length < 11 ||
      input.length > 11)
  ) {
    return false;
  }

  return true;
};

export const competitionLevels = () => {
  return [
    {
      id: 1,
      name: "کشوری",
    },
    {
      id: 2,
      name: "منطقه ای",
    },
    {
      id: 3,
      name: "استانی",
    },
    {
      id: 4,
      name: "باشگاه",
    },
  ];
};

export const competitionLevelCase = (number) => {
  switch (number) {
    case 1:
      return "کشوری";
    case 2:
      return " منطقه ای";
    case 3:
      return "استانی";
    case 4:
      return "باشگاه";
    default:
      return "تعریف نشده";
  }
};

export const matchGenderLabel = (gender) => {
  switch (Number(gender)) {
    case 1:
      return "مرد";
    case 2:
      return "زن";
    case 3:
      return "مشترک";
    default:
      return "";
  }
};

/** Maps user profile gender (0=female, 1=male) to match gender (1=male, 2=female). */
export const userGenderToMatchGender = (userGender) => {
  if (userGender === 0 || userGender === "0") {
    return 2;
  }
  if (userGender === 1 || userGender === "1") {
    return 1;
  }
  return null;
};

export const userFitsMatchGender = (matchGender, userGender) => {
  if (Number(matchGender) === 3) {
    return true;
  }
  const mapped = userGenderToMatchGender(userGender);
  return mapped !== null && Number(matchGender) === mapped;
};

export const serverErrorHandler = (errors, setServerErrors, serverErrors) => {
  let allErrors = {};
  Object.entries(errors).forEach((el) => {
    allErrors[[el[0]]] = el[1][0];
  });
  setServerErrors(allErrors);
};

const MATCH_KIND_NAME_TO_KEY = {
  انفرادی: 'single',
  تیمی: 'team',
  دوبل: 'double',
  لیگ: 'league',
};

export const resolveMatchRegistrationKind = (kinds) => {
  const kind = kinds?.[0];
  if (!kind) {
    return { key: 'single', id: 1 };
  }
  return {
    key: MATCH_KIND_NAME_TO_KEY[kind.name] || 'single',
    id: kind.id,
  };
};
